import { render, staticRenderFns } from "./BranchDashboard.vue?vue&type=template&id=d886907a&scoped=true"
import script from "./BranchDashboard.vue?vue&type=script&lang=js"
export * from "./BranchDashboard.vue?vue&type=script&lang=js"
import style0 from "./BranchDashboard.vue?vue&type=style&index=0&id=d886907a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d886907a",
  null
  
)

export default component.exports